<template>
  <div class="d-flex border rounded p-1 p-md-2 mb-3 calendar-container">
    <div
      class="d-flex justify-content-center align-items-center mr-1 mt-2 mt-md-0 mt-sm-2"
      :class="{
        'calendar-box': hasNegative(value.serviceCostTotalAmt),
        'calendar-box-red': !hasNegative(value.serviceCostTotalAmt),
      }"
    >
      <span>{{ value.assistanceDay }}</span>
    </div>
    <div class="pl-1 pr-0 flex-grow-1">
      <div class="pt-1 border__bottom--secondary-27 pb-1">
        <div class="d-flex justify-content-center align-items-center">
          <span
            class="font-13 font-weight-bold"
            :class="{
              'color-green': hasNegative(value.serviceCostTotalAmt),
              'color-secondary-28': !hasNegative(value.serviceCostTotalAmt),
            }"
          >
            {{ value.serviceCostTotalAmt | price }}
          </span>
        </div>
      </div>
      <div class="d-flex justify-content-center pb-1">
        <div class="font-weight-bold font-13">{{ formula(value) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalendarCard',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    hasNegative() {
      return (price) => Math.sign(price) > 0;
    },
    formula() {
      return (val) =>
        `$0.40 x ${parseFloat(val.milesAmt)} mi ${
          val.hasCompanion ? 'x 2' : ''
        }`;
    },
  },
};
</script>

<style scoped lang="scss">
.calendar-box-red {
  background: url('../../../../assets/img/calendar-regular-red.svg');
}
.calendar-box {
  background: url('../../../../assets/img/calendar-regular.svg');
}
.calendar-box-red,
.calendar-box {
  background-size: cover;
  width: 47px;
  height: 52px;
  span {
    font-size: 20px;
    margin-top: 10px;
    font-weight: bold;
  }
}
.price-size {
  font-size: 7px;
}

@media only screen and (max-width: 768px) {
  span {
    font-size: 9px !important;
  }
  .icon-user,
  .icon-car {
    font-size: 10px !important;
    margin-right: 3px !important;
  }
  .price-size {
    font-size: 6px !important;
  }
  .calendar-box-red,
  .calendar-box {
    width: 27px !important;
    height: 30px !important;
  }
}
</style>
